import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Product } from '../../products/product';
import { FileDownloadService } from '../../products/file-download.service';
import { UrlHandlingStrategy } from '@angular/router';
import { FavoritesService } from '../../products/favorites.service';
import { Configuration } from '../../configuration';
import { ConfigurationService } from '../../configuration.service';
import { LoginReminderModalComponent } from '../../login-reminder-modal/login-reminder-modal.component';
import { MatDialog } from '@angular/material';


@Component({
  selector: 'app-slide',
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.scss']
})
export class SlideComponent implements OnInit {
  imageBase: string = "";
  config:Configuration = {license: ''};
  filesize:number = 0;

  @Input()
  imageSrc: string;

  @Input()
  thumbHeight: number;

  // @Input()
  // config:Configuration = {license: ''};


  favourited: boolean = false;
  thumbObj: any = {};

  private _item: Product;

  @Input() set item(value: Product) {

    this.filesize = (value.file_size/1000000);
    if (this.filesize < 1) {
      value.filesize = '< 1 MB';
    } else {
      value.filesize = Math.round(this.filesize)+" MB";
    }

    value.categoryString = (value.category)? value.category.reduce(
      function(a, b) {
        return a + ' / ' + b.title;
      },
      ''
    ): '';

    if (!value.category) {
      this.favourited = true;
    }

    // style="background: url({{imageBase}}{{imageSrc}})" 100% auto
    this.thumbObj = {
    'background':
    `url(${environment.imageBase + this.imageSrc}) no-repeat top center`,
    'background-size': 'contain',
    //flex: `1 0 ${this.thumbHeight || 150}px`
    flex: `1 0 150px`
  };

    this._item = value;

  }
  get item(): Product {
    // other logic

    return this._item;
  }

  get isHdr(): boolean {
  if (this.imageSrc) {
      var imageParts = this.imageSrc.split('.');
      if (imageParts[1])
        return imageParts[1] == 'hdr';
    } else {
      return false;
    }

  }

  constructor(
    private fd: FileDownloadService,
    private favoritesService:FavoritesService,
    public dialog: MatDialog,
    private configurationService: ConfigurationService
  ) {
    this.imageBase = `${environment.imageBase}`;
    this.config = configurationService.getConfigurationCache();
   }

   favouriteItem(event){

    const favourite = !this.favourited;

    this.favoritesService.favoriteToggle(this.item, favourite)
    .subscribe(result => {

      this.favourited = result;
    })

   }

   openUpLicense(event){

    const dialogRef = this.dialog.open(LoginReminderModalComponent, {
      //  height: '100px',
    });

   }

   fileDownload(event){
   console.log(event);
     if (this.item.type === 'free' || (this.config && this.config.license != '' && this.config.license != null)){
     this.fd.fetchProduct(this.item, this.config)
     .subscribe((results: any) => {
          console.log('file download', results);
        },
        err => console.error(err),
        () => console.log('done loading services x')
      );
    } else {
      console.log('not logged in so canot download');
    }
   }

  ngOnInit() {
    // console.log('this.config', this.config)

    this.configurationService.getConfigurationSubject()
    .subscribe((config:Configuration)=> {
      this.config = config;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/product-carousel/slide/slide.component.ts